// extracted by mini-css-extract-plugin
export default {"cityTag":"ay5hb","button":"by5hb","external":"cy5hb","icon":"dy5hb"};